<template>
    <div>
        <ui-crud title="Request for materials" subtitle="All Request for Materials for this package"
                 ref="crud"
                 :fetch="fetch" :pipe-with="pipeItems" :group-by="groupByStatus">
            <template #new-button>
                <div class="flex items-center">
                    <h1 class="text-lg font-medium text-gray-900">Request for materials</h1>
                    <ui-button-new small class="ml-auto hidden sm:inline-flex" icon="fas fa-plus"
                                   v-if="packageReference"
                                   @click.prevent="createNew()">New
                    </ui-button-new>
                </div>
                <p class="mt-1 text-sm text-gray-600">All Request for Materials for this package</p>
                <ui-button-new class="sm:hidden mt-4" icon="fas fa-plus" v-if="packageReference"
                               @click.prevent="createNew()">New
                </ui-button-new>
            </template>

            <!-- Filters. -->
            <template #filters>
                <div class="relative">
                    <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                    <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </template>

            <!-- List item. -->
            <template #list-item="{ item, select, active, setEditMode }">
                <ui-crud-card
                    :ref="'item-'+item.id"
                    :titleAsHtml="getItemTitle(item)"
                    :subtitle="item.packageName"
                    :metadata="item.requestedFor"
                    :active="active"
                    :manual="() => selectItem(item,select,setEditMode)"
                    @click="selectItem(item,select,setEditMode)"
                ></ui-crud-card>
            </template>

            <!-- Create form. -->
            <template #create="{ addItem, setEditMode, selectItem }">
                <div class="flex space-x-8 pt-4 px-4 m-4 justify-center items-center">
                    <div
                        class="border border-grey-200 rounded-l bg-gray-50 w-full h-full p-4 justify-center items-center text-center text-gray-500">
                        <-- Please select an existing Request for Materials to view/edit or click new to create a new
                        one.
                    </div>
                </div>
            </template>

            <template #edit="{ selectedItem, setEditMode, removeItem }">
                <request-for-materials-edit :package-reference="selectedItem.packageReference"
                                            :package-name="selectedItem.packageName"
                                            :requestForMaterialsId="selectedItem.id" :item="selectedItem"
                                            :remove-item="removeItem"
                                            @statusChanged="statusChanged"
                ></request-for-materials-edit>
            </template>

            <!-- Show page. -->
            <template #show="{ selectedItem, setEditMode, removeItem, addItem, selectItem }">
                <request-for-materials-show :package-reference="selectedItem.packageReference"
                                            :package-name="selectedItem.packageName"
                                            :requestForMaterialsId="selectedItem.id" :item="selectedItem"
                                            @statusChanged="statusChanged"
                                            :readonly="true"
                ></request-for-materials-show>
            </template>
        </ui-crud>
    </div>
</template>

<script>

import {ProjectDeliveryRequestForMaterials as RequestForMaterials} from "@models";
import RequestForMaterialsShow from "./RequestForMaterialsShow.vue";
import RequestForMaterialsEdit from "./RequestForMaterialsEdit.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {uuid} from "../../../utils";
import UiCrud from "../../ui/UiCrud.vue";

export default {
    components: {UiCrud, RequestForMaterialsEdit, UiButtonNew, RequestForMaterialsShow},
    props: {
        packageReference: null,
        packageName: null,
        admin: Boolean,
    },
    computed: {},
    data() {
        return {
            search: '',
            noContract: false,
        }
    },
    methods: {
        async createNew() {
            let id = uuid();
            await RequestForMaterials.create(this.packageReference, this.packageName, id)
            await this.$refs.crud.fetchItems();
            this.$refs.crud.selectItem(this.$refs.crud.items.find((i) => i.id === id), true);
        },
        async statusChanged(item, requestForMaterials) {
            await this.$refs.crud.fetchItems();
            this.$refs['item-'+item.id].$listeners.click();
        },
        getItemTitle(item) {
            return 'RFM #' + item.reference;
        },
        selectItem(item, select, setEditMode) {
            select()
            if (item.status === 'Draft') {
                setEditMode(true)
            } else {
                setEditMode(false)
            }
        },
        async fetch() {
            return await RequestForMaterials.all(this.packageReference)
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((pr) => {
                    return query.every((token) => {
                        return pr.tokens.includes(token);
                    })
                });
            }
            return items;
        },
        groupByStatus(item) {
            return item.status
        },
    },
}
</script>
